import { render, staticRenderFns } from "./flow-list.vue?vue&type=template&id=1a3a36e4&"
import script from "./flow-list.vue?vue&type=script&lang=ts&"
export * from "./flow-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports